import { select } from 'redux-saga/effects'
import { delay } from 'Helper/customReduxEffects.js'
import debug from 'Helper/debugHelpers'

// this executes the the XtractAPI objects okToSubmitCalls function and loops
// until it returns true. This allows the calling application to controll when
// calls are allowed to be submitted vs when they wait. The default for this
// package is for okToSubmitCalls to return true so no waits occur but the
// primary usage from outside this package would be for the parent application
// to have a function that returns false when in the middle of doing a token
// refresh so that api calls don't continue to be submitted with the old token.
// Once the refresh completes, okToSubmitCalls begins returning true again and
// all waiting calls continue using the new tokens.
export default function * checkOkToProceed(action) {
  let auth = yield select(state => state.auth)
  let ok = auth.refreshInProgress === false
  const { resource, method } = action
  let count = 0
  while (ok === false && count < 240) {
    if (count === 0) {
      debug.log(
        `${method} call to ${resource} paused waiting on token refresh`,
        debug.logLevels.API
      )
    }
    yield delay(250)
    count++
    auth = yield select(state => state.auth)
    ok = auth.refreshInProgress === false
  }
  if (count !== 0) {
    debug.log(
      `${method} call to ${resource} released after token refresh`,
      debug.logLevels.API
    )
  } else if (ok === false) {
    debug.log(
      `Refresh call hung during ${method} call to ${resource}`,
      debug.logLevels.API,
      'error'
    )
  }
}
